import { type ProductData } from "../../../models/ProductData";
import { Link } from "../Link";
import { Trans } from "react-i18next";
import { userIsLoggedIn } from "../../../utils/roles";
import { hasSuccessor } from "~/utils/productUtils";
import { Alert } from "~/common/m3/Alert/Alert";

interface Props {
  baseProduct: { successorProduct?: Pick<ProductData, "url" | "designation"> };
  className?: string;
  disableLink?: boolean;
  onClick?: () => void;
}

export const NewVersionMessage = ({ baseProduct, disableLink, onClick, ...rest }: Props) => {
  if (!userIsLoggedIn() || !hasSuccessor(baseProduct)) {
    return null;
  }

  const successorProduct = baseProduct.successorProduct;

  if (disableLink && !onClick) {
    return (
      <Alert severity={"info"} {...rest}>
        <Trans i18nKey={"product.hasNewerVersion"}>
          newer version is existing <span className={"d-inline"}>{{ name: successorProduct.designation }}</span>
        </Trans>
      </Alert>
    );
  }

  return (
    <Alert severity={"info"} {...rest}>
      <Trans i18nKey={"product.hasNewerVersion"}>
        newer version is existing{" "}
        <Link className={"d-inline"} href={disableLink ? undefined : successorProduct.url} onClick={onClick}>
          {{ name: successorProduct.designation }}
        </Link>
      </Trans>
    </Alert>
  );
};
